//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../no/Builder.js";
let d=[[[0,"BogieWheelbase",1,0],[0,"Camber",1,0],[0,"CoordinateX",1,0],[0,"CoordinateY",1,0],[0,"CoordinateZ",1,0],[0,"Diameter",1,0],[0,"FlangeDiameter",1,0],[0,"FlangeWidth",1,0],[0,"Name",1,0],[0,"PositionDefinition",1,0],[0,"RimOffset",1,0],[0,"ShowSurface",1,0],[0,"ShowWireframe",1,0],[0,"StaticRadius",1,0],[0,"Toe",1,0],[0,"Track",0,0],[0,"WheelTabIsEdit",1,0],[0,"Width",1,0]],[],[]];
SPLM.Features.VehicleDesign.BaseDataWheelBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.BaseDataWheelBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.BaseDataWheelBuilder.PositionDefinitionOptions = Object.freeze({
    "WheelCenterPoint" : "WheelCenterPoint", "AttachmentPointRimOffset" : "AttachmentPointRimOffset"});

export default SPLM;